import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Spinner, Alert, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../api/apiClient';
import { useCart } from '../../../contexts/CartContext';

const StripeReturnPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshCart } = useCart();

  const paymentId = searchParams.get('paymentId');
  const sessionId = searchParams.get('session_id');

  const [isProcessing, setIsProcessing] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const finalizePayment = async () => {
      if (!paymentId || !sessionId) {
        setErrorMessage('Missing Stripe confirmation details.');
        setIsProcessing(false);
        return;
      }

      try {
        await api.payments.captureStripe({ paymentId, sessionId });
        await refreshCart();
        navigate(`/user/payment-success?paymentId=${paymentId}`, { replace: true });
      } catch (error) {
        console.error('Stripe capture error', error);
        const message = error.response?.data?.message || 'Failed to confirm Stripe payment.';
        setErrorMessage(message);
        setIsProcessing(false);
      }
    };

    finalizePayment();
  }, [navigate, sessionId, paymentId, refreshCart]);

  if (isProcessing) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="success" />
        <p className="text-muted mt-3 mb-0">Confirming your Stripe payment...</p>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <Card className="border-0 shadow-sm">
        <Card.Body className="p-4 text-center">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger bg-opacity-10 mb-3" style={{ width: '96px', height: '96px' }}>
            <i className="fas fa-times text-danger" style={{ fontSize: '38px' }}></i>
          </div>
          <h4 className="fw-bold text-dark">Payment Confirmation Failed</h4>
          <Alert variant="light" className="mt-3 mb-4">
            <div className="d-flex align-items-start">
              <i className="fas fa-info-circle me-2 mt-1 text-danger"></i>
              <span>{errorMessage}</span>
            </div>
          </Alert>
          <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
            <Button variant="danger" onClick={() => navigate('/user/payment/select')}>
              <i className="fas fa-redo me-2"></i>
              Try Again
            </Button>
            <Button variant="outline-secondary" onClick={() => navigate('/user/cart')}>
              <i className="fas fa-shopping-cart me-2"></i>
              Back to Cart
            </Button>
          </div>
        </Card.Body>
      </Card>
    );
  }

  return null;
};

export default StripeReturnPage;

